export const numberOfPeople = 3
export const numberOfCameras = 10
